module.exports = __webpack_public_path__ + "img/65.6c7c76f7.png";